import React from 'react';

const SingleCourse = () => {
    return (
        <div className="col-xl-3 col-lg-4 col-md-6 grid-item cat1 cat4 cat5" >
            <div className="course-wrapper white-bg mb-30">
                <div className="course-inner">
                    <div className="course-img course-img-02 pos-rel mb-25">
                        <a href="courses-details.html"><img src="https://www.devsnews.com/template/micoach/micoach/assets/img/course/c-04.jpg" alt="" /></a>
                        <div className="course__instructor pos-abl d-flex align-items-center">
                            <div className="course__instructor--thumb">

                                <h5>Sanjoy Banik </h5>
                            </div>
                            <div className="course__instructor--price-tag">
                                <span>৳ ৪০০০ </span>
                            </div>
                        </div>
                    </div>
                    <div className="course-text course-text-inner">
                        <h5 className="semi-title pb-25 mb-25"><a href="courses-details.html">কম্পিউটার অফিস অ্যাপ্লিকেশন</a></h5>
                        <p className="semi-desc">বাংলাদেশ কারিগরি শিক্ষা বোর্ড কর্তৃক অনুমোদিত Advanced IT Institute (প্রতিষ্ঠান কোড: ৫৬০৭৩)</p>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default SingleCourse;